module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "icon": "pi pi-search",
      "label": "Search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchOrder.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Reason",
      "visible": _vm.ecommerceStatusDialog,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.ecommerceStatusDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "label": "Send"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.updateOrderStatus.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [(this.salesOrderList.length > 0 && this.$store.getters.modules.includes('5.38')) ? _c('a', {
    staticClass: "p-field p-col-12 p-md-12",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right",
      "height": "3em",
      "width": "3em"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('DataTable', {
    ref: "dt",
    staticClass: " p-datatable-gridlines editable-cells-table",
    attrs: {
      "value": _vm.salesOrderLists,
      "dataKey": "id",
      "paginator": true,
      "editMode": "cell",
      "rowsPerPageOptions": [100, 500, 1000],
      "rows": 100,
      "filters": _vm.filters,
      "selection": _vm.selectedProduct1,
      "selectionMode": "single"
    },
    on: {
      "update:selection": function($event) {
        _vm.selectedProduct1 = $event
      }
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n              " + _vm._s(sl.index + 1) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Miti",
      "headerStyle": "width:8em;",
      "sortable": true,
      "field": "purchaseSalesDateNepali",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['purchaseSalesDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'purchaseSalesDateNepali', $$v)
            },
            expression: "filters['purchaseSalesDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date",
      "headerStyle": "width:8em;",
      "sortable": true,
      "field": "purchaseSalesDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['purchaseSalesDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'purchaseSalesDate', $$v)
            },
            expression: "filters['purchaseSalesDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Order No",
      "sortable": true,
      "field": "orderNo",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['orderNo']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'orderNo', $$v)
            },
            expression: "filters['orderNo']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer",
      "sortable": true,
      "field": "accountName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['accountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'accountName', $$v)
            },
            expression: "filters['accountName']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                Total:\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Address",
      "sortable": true,
      "field": "address",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['address']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'address', $$v)
            },
            expression: "filters['address']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Store",
      "sortable": true,
      "field": "warehouse.name",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['warehouse.name']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'warehouse.name', $$v)
            },
            expression: "filters['warehouse.name']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Order From",
      "sortable": true,
      "field": "orderFrom",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['orderFrom']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'orderFrom', $$v)
            },
            expression: "filters['orderFrom']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Total",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "totalBillAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['totalBillAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'totalBillAmount', $$v)
            },
            expression: "filters['totalBillAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalSumBillAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "ecommerceStatus",
      "header": "Status",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['ecommerceStatus']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'ecommerceStatus', $$v)
            },
            expression: "filters['ecommerceStatus']"
          }
        })]
      },
      proxy: true
    }, {
      key: "editor",
      fn: function(slotProps) {
        return [_c('Dropdown', {
          attrs: {
            "options": _vm.statuses,
            "optionLabel": "label",
            "optionValue": "value",
            "placeholder": "Select a Status",
            "disabled": slotProps.data['ecommerceStatus'] === 'Completed' ? true : false
          },
          on: {
            "change": function($event) {
              return _vm.showReasonDialog(slotProps.data)
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(slotProps) {
              return [_c('span', {
                class: 'product-badge status-' + slotProps.option.value.toLowerCase()
              }, [_vm._v(_vm._s(slotProps.option.label))])]
            }
          }], null, true),
          model: {
            value: (slotProps.data['ecommerceStatus']),
            callback: function($$v) {
              _vm.$set(slotProps.data, 'ecommerceStatus', $$v)
            },
            expression: "slotProps.data['ecommerceStatus']"
          }
        })]
      }
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n              " + _vm._s(_vm.getStatusLabel(slotProps.data.ecommerceStatus)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Org Name",
      "sortable": true,
      "field": "organisationName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['organisationName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'organisationName', $$v)
            },
            expression: "filters['organisationName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "headerStyle": "width:12em;"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.enableEdit) ? _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Edit'),
            expression: "'Edit'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editSalesOrder(slotProps.data)
            }
          }
        }) : _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Edit'),
            expression: "'Edit'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil",
            "disabled": ""
          },
          on: {
            "click": function($event) {
              return _vm.editSalesOrder(slotProps.data)
            }
          }
        }), _vm._v(" "), (_vm.enableDelete) ? _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Delete'),
            expression: "'Delete'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        }) : _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Delete'),
            expression: "'Delete'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "disabled": "",
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        }), _vm._v(" "), _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('View Details'),
            expression: "'View Details'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised",
          attrs: {
            "icon": "pi pi-eye"
          },
          on: {
            "click": function($event) {
              return _vm.viewPIVDetail(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Print'),
            expression: "'Print'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-secondary",
          attrs: {
            "icon": "pi pi-print"
          },
          on: {
            "click": function($event) {
              return _vm.exportToPdf(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteReport
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-537e75b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/salesReport/salesOrderReport.vue
// module id = 2234
// module chunks = 0